import { Component, Input } from '@angular/core';
import { theme } from '../../../data/theme';
import { environment } from '../../../environments/environment';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    theme = theme;
    CurntVersion = environment.Versioning;
    CurrentYear = (new Date()).getFullYear();
    @Input() isLoggedIn
    constructor() { }


}
